import { Injectable, OnDestroy } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, Subject } from 'rxjs';
import { ILoginBody } from '../models/login-body.model';
import { AuthEnum } from '../enums/auth.enum';
import { LocalStorageEnum } from '../enums/token.enum';

@Injectable({
  providedIn: 'root'
})
export class AuthService implements OnDestroy {
  private _resourceUrl = 'https://devmavalue.plataforma-smart.com';
  private readonly _unsubscribe$ = new Subject<boolean>();
  private fromLoginPage = false;

  constructor(private _apiService: ApiService) {}

  login(body: ILoginBody): Observable<{ token: string }> {
    return this._apiService.post(`${AuthEnum.API}/${AuthEnum.API_TOKEN_AUTH}/`, body) as Observable<{ token: string }>;
  }

  setLocalStorageAccessToken(loginResponse: string): void {
    localStorage.setItem(LocalStorageEnum.TOKEN, loginResponse);
  }

  getLocalStorageAccessToken(): string {
    return localStorage.getItem(LocalStorageEnum.TOKEN) || '';
  }

  setLocalStorageLanguage(userLanguage: string): void {
    localStorage.setItem(LocalStorageEnum.LANGUAGE, userLanguage);
  }

  getLocalStorageLanguage(): string {
    return localStorage.getItem(LocalStorageEnum.LANGUAGE)!;
  }

  setLocalStorageCountry(userLanguage: string): void {
    localStorage.setItem(LocalStorageEnum.COUNTRY, userLanguage);
  }

  getLocalStorageCountry(): string {
    return localStorage.getItem(LocalStorageEnum.COUNTRY)!;
  }
  setLocalStorageSelectedLang(userLanguage: string): void {
    localStorage.setItem(LocalStorageEnum.SELECTED_LANG, userLanguage);
  }

  getLocalStorageSelectedLang(): string {
    return localStorage.getItem(LocalStorageEnum.SELECTED_LANG)!;
  }

  setLocalStorageUserAuth(userAuth: string): void {
    localStorage.setItem(LocalStorageEnum.USER_AUTH, userAuth);
  }

  getLocalStorageUserAuth(): string {
    return localStorage.getItem(LocalStorageEnum.USER_AUTH)!;
  }

  setFromLogin(value: boolean) {
    this.fromLoginPage = value;
  }

  isFromLogin(): boolean {
    return this.fromLoginPage;
  }

  clear() {
    this.fromLoginPage = false;
  }
  ngOnDestroy(): void {
    this._unsubscribe$.next(true);
    this._unsubscribe$.complete();
  }
}
